{
    "Accessibility menu": "접근성 메뉴",
    "Close": "닫기",
    "Text and Reading": "텍스트 및 읽기",
    "Navigation and Interaction": "탐색 및 상호작용",
    "Text Align": "텍스트 정렬",
    "Align Left": "왼쪽 정렬",
    "Align Center": "가운데 정렬",
    "Align Right": "오른쪽 정렬",
    "Adjust Font Size": "글꼴 크기 조정",
    "Highlight Title": "제목 강조",
    "Highlight Links": "링크 강조",
    "Readable Font": "가독성 좋은 글꼴",
    "Color and Contrast": "색상 및 대비",
    "Dark Contrast": "어두운 대비",
    "Light Contrast": "밝은 대비",
    "High Contrast": "높은 대비",
    "High Saturation": "높은 채도",
    "Low Saturation": "낮은 채도",
    "Monochrome": "단색",
    "Tools": "도구",
    "Reading Guide": "읽기 가이드",
    "Big Cursor": "큰 커서",
    "Increase Font Size": "글꼴 크기 증가",
    "Decrease Font Size": "글꼴 크기 감소",
    "Letter Spacing": "자간",
    "Line Height": "줄 간격",
    "Font Weight": "글꼴 두께",
    "Dyslexia Font": "난독증용 글꼴",
    "Language": "언어",
    "Accessibility widget": "접근성 메뉴 열기",
    "Accessibility Profiles": "접근성 프로필",
    "Cognitive Disability": "인지 장애",
    "Seizure Safe": "발작 안전",
    "Accessibility statement": "접근성 정책",
    "ADHD": "ADHD",
    "Low Vision": "저시력",
    "Pause Animations": "애니메이션 중지",
    "Animation paused": "애니메이션 일시정지됨",
    "Reset all settings": "설정 초기화",
    "Shortcut:": "단축키:",
    "Epilepsy Safe Mode": "뇌전증 안전 모드",
    "Mute sounds": "소리 음소거",
    "Page read": "페이지 읽기",
    "Page read controls": "페이지 읽기 제어",
    "Pause": "일시정지",
    "Resume": "다시 시작",
    "Stop": "정지",
    "Settings": "설정",
    "Speed": "속도",
    "Voice": "음성",
    "Close accessibility menu": "접근성 메뉴 닫기",
    "Back to accessibility menu": "접근성 메뉴로 돌아가기",
    "Search languages": "언어 검색",
    "Selected language": "선택된 언어",
    "View accessibility statement (opens in new window)": "접근성 정책 보기(새 창에서 열림)",
    "Visit CookieYes website (opens in new window)": "CookieYes 웹사이트 방문(새 창에서 열림)",
    "Reset all accessibility settings to default": "모든 접근성 설정을 기본값으로 재설정"
}
